import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { state: Object };

  stateValueChanged() {
    this.dispatch('changed', { detail: this.stateValue });
  }
}
